export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_03_powereddge_facts_loop.f210cf4d.mp4";